import React from "react";
import { Link,useLocation } from "react-router-dom";
const ProductsBanner = () => {
    const location = useLocation();

const path = location.pathname.toLowerCase();

let backgroundImage = "/assets/img/breadcrumb/slider11.png"; // default

if (path.includes("fire%20safety")) {
  backgroundImage = "/assets/img/bg/3.jpg";
} else if (path.includes("green%20energy")) {
  backgroundImage = "/assets/img/bg/1.jpg";
}

  return (
    <>
      <section
        className="breadcrumb__area include-bg breadcrumb__overlay Product_banner"
        // data-background="assets/img/breadcrumb/slider11.png"
        style={{
               backgroundImage: `url("${backgroundImage}")`,
          zIndex: "0",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xxl-12">
              <div className="breadcrumb__content text-center p-relative z-index-1">
                <h3 className="breadcrumb__title">Our Project</h3>
                <div className="breadcrumb__list">
                  <span>
                    <Link to="/">Home</Link>
                  </span>
                  <span className="dvdr">:</span>
                  <span>Project</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductsBanner;
